import React from "react";
// react library for routing
import { Route, Switch, Redirect, useHistory, useLocation } from "react-router-dom";
// redux
import { useDispatch, useSelector } from 'react-redux'
// moment.js
import moment from 'moment';

// firebase
import firebase from 'firebase/app';

// User actions
import { setUserData } from './actions/userActions'

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import Loading from 'components/Misc/Loading'

function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const userState = useSelector(state => state.user);
  const [loadingActive, setLoadingActive] = React.useState(true);
  /* 
    We will listen for user state changes from the root to handle redirects
    and prevent users from lingering in the app if for whatever reason
    they need to be logged out immediately
  */

  React.useEffect(() => {
    if (location.pathname === '/auth/feedback') return setLoadingActive(false);
    firebase.auth().onAuthStateChanged(async user => {
      dispatch(setUserData(user))
      if (user && user.uid) {
        const token = await user.getIdTokenResult(true)
        let plan;
        let cancelWarning;
        if (token.claims.role && token.claims.role === 'owner') {
          const planSnapshot = await firebase
            .firestore()
            .collection('customers')
            .doc(user.uid)
            .collection('subscriptions')
            .get()

          planSnapshot.forEach(doc => {
            if (doc.exists) {
              if (moment().diff(moment(doc.data().cancel_at.toDate()), 'days') >= 60 && moment().diff(moment(doc.data().cancel_at.toDate()), 'days') < 90) {
                cancelWarning = 90 - moment().diff(moment(doc.data().cancel_at.toDate()), 'days');
              }
              doc.data().items.forEach(item => {
                if (!item.plan.active) return;
                plan = item.plan.interval;
              })
            }
          })
        }
        dispatch(setUserData({
          ...user,
          role: token.claims.role,
          franchises: token.claims.franchises,
          plan: plan || 'free',
          cancelWarning,
        }))
        setLoadingActive(false);
        if (token.claims.role) {
          return history.push('/admin/dashboard');
        } else {
          return history.push('/auth/welcome')
        }
      }
      setLoadingActive(false);
      return history.push('/auth/login');
    })
  }, []);

  if (loadingActive) {
    return (<Loading active={loadingActive}/>)
  }

  return(
    <Switch>
      <Redirect from="/" exact to="/auth" />
      <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
      <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
      <Redirect from="*" to="/" />
    </Switch>
  )
  };

export default App;
